var _style, _defs, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgBannerMinimal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 800",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        @keyframes gentleFloat {\n            0%, 100% { transform: translateY(0); opacity: 0.5; }\n            50% { transform: translateY(-12px); opacity: 0.8; }\n        }\n        .floating {\n            animation: gentleFloat 10s ease-in-out infinite;\n        }\n        \n        @media (max-width: 980px) {\n            .bottom-space {\n                fill: #fafafa;\n            }\n        }\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pinkGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff9ed8",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d51b81",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffe45c",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eab413",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#72ccdf",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#72ccdf",
    stopOpacity: 0.12
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "floating",
    cx: 220,
    cy: 220,
    r: 120,
    fill: "url(#blueGradient)",
    style: {
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "floating",
    cx: 750,
    cy: 220,
    r: 140,
    fill: "url(#pinkGradient)",
    style: {
      animationDelay: "1s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "floating",
    cx: 1000,
    cy: 120,
    r: 100,
    fill: "url(#goldGradient)",
    style: {
      animationDelay: "2s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "floating",
    cx: 950,
    cy: 280,
    r: 60,
    fill: "url(#blueGradient)",
    style: {
      animationDelay: "3s"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "bottom-space",
    x: 0,
    y: 680,
    width: 1200,
    height: 120,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgBannerMinimal);
export default __webpack_public_path__ + "static/media/svgBannerMinimal.22f1e36e601c957be4c2b4682ac4d13c.svg";
export { ForwardRef as ReactComponent };